export async function generateFaceID(imageFile) {
  if (!imageFile) {
    throw new Error("No image file provided");
  }

  const formData = new FormData();
  formData.append("image", imageFile);

  try {
    const response = await fetch("https://api.simli.ai/generateFaceID", {
      method: "POST",
      headers: {
        "api-key": "n8sesdejo1tnudor5ljcg",
      },
      body: formData,
    });

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`Upload failed: ${response.status} - ${errText}`);
    }

    const data = await response.json();

    if (data.character_uid) {
      return data.character_uid;
    } else {
      throw new Error("Face ID could not be retrieved");
    }
  } catch (err) {
    throw new Error("Failed to generate face ID: " + err.message);
  }
}

export async function getAvatarPreview(faceId) {
  if (!faceId) {
    throw new Error("Face ID is required");
  }

  try {
    const response = await fetch(
      `https://api.simli.ai/getRequestStatus?face_id=${faceId}`,
      {
        method: "POST",
        headers: { "api-key": "n8sesdejo1tnudor5ljcg" },
      }
    );

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(
        `Failed to get avatar preview: ${response.status} - ${errText}`
      );
    }

    const data = await response.json();

    if (data.image_url) {
      return data.image_url;
    } else {
      throw new Error("No preview image URL found");
    }
  } catch (err) {
    throw new Error("Failed to get avatar preview: " + err.message);
  }
}
